import { Map } from 'immutable';

import { EditableSection } from '®shared/reading-list/models';

import {
  ContainerEditActionTypes,
  ContainerEditActions,
} from './container-edit.actions';
import { extractSectionIdLookup } from './container-structure-utils';
import { ContainerActionTypes, ContainerActions } from './container.actions';

export function sectionsByIdReducer(
  state: Map<string, EditableSection>,
  action: ContainerActions | ContainerEditActions,
): Map<string, EditableSection> {
  switch (action.type) {
    case ContainerActionTypes.CONTAINER_INITIALISED: {
      const { container } = action.payload;
      return state.merge(extractSectionIdLookup(container));
    }

    case ContainerEditActionTypes.CANCEL_CREATE_SECTION: {
      const { id } = action.payload;
      return state.remove(id);
    }

    case ContainerEditActionTypes.CONFIRM_CREATE_SECTION:
    case ContainerEditActionTypes.CONFIRM_UPDATE_SECTION: {
      const { id, title, description } = action.payload;
      const section: EditableSection = {
        id,
        type: 'sections',
        title,
        description,
      };
      return state.merge({ [section.id]: section });
    }

    case ContainerEditActionTypes.CONFIRM_DELETE_SECTION: {
      const { section, descendantSections } = action.payload;
      return state.remove(section.id).removeAll(descendantSections);
    }

    case ContainerEditActionTypes.CREATE_SECTION: {
      const { id } = action.payload;
      const section: EditableSection = {
        id,
        type: 'sections',
        title: '',
        description: undefined,
      };
      return state.merge({ [section.id]: section });
    }

    default: {
      return state;
    }
  }
}
